const Map = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5023 3.8C10.3755 3.8 8.65229 5.52292 8.65229 7.64708C8.65229 10.1038 10.1092 12.7479 11.4395 14.6239C11.9913 15.4021 13.0397 15.4001 13.5886 14.6201C14.9082 12.7447 16.3523 10.1029 16.3523 7.64708C16.3523 5.52292 14.6291 3.8 12.5023 3.8ZM6.85229 7.64708C6.85229 4.52776 9.38241 2 12.5023 2C15.6222 2 18.1523 4.52776 18.1523 7.64708C18.1523 10.695 16.4152 13.7309 15.0607 15.6559C13.7964 17.4527 11.242 17.4572 9.97124 15.6651C8.60655 13.7407 6.85229 10.7004 6.85229 7.64708Z"
        fill="#434242"
      />
      <path
        d="M14.2523 7.74998C14.2523 8.71647 13.4688 9.49998 12.5023 9.49998C11.5358 9.49998 10.7523 8.71647 10.7523 7.74998C10.7523 6.78348 11.5358 5.99998 12.5023 5.99998C13.4688 5.99998 14.2523 6.78348 14.2523 7.74998Z"
        fill="#434242"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.711 14.3208C18.0309 13.9403 18.5986 13.8912 18.9791 14.211C19.8118 14.911 20.5046 15.7999 20.5046 17C20.5046 18.7532 19.4408 20.0376 17.966 20.8364C16.5105 21.6248 14.5721 22.0015 12.5 22.0015C10.4096 22.0015 8.4728 21.5699 7.02462 20.7575C5.5775 19.9456 4.5 18.6694 4.5 17C4.5 15.8112 5.21235 14.9041 6.01422 14.2167C6.39159 13.8932 6.95976 13.9368 7.28327 14.3142C7.60677 14.6916 7.5631 15.2597 7.18573 15.5832C6.53417 16.1418 6.3 16.5935 6.3 17C6.3 17.7887 6.79248 18.5633 7.90534 19.1876C9.01715 19.8114 10.6303 20.2015 12.5 20.2015C14.3879 20.2015 16.0018 19.8532 17.1087 19.2537C18.1961 18.6647 18.7046 17.8983 18.7046 17C18.7046 16.5791 18.4849 16.1471 17.8209 15.5889C17.4404 15.269 17.3912 14.7013 17.711 14.3208Z"
        fill="#434242"
      />
    </svg>
  );
};

export default Map;
